<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="isCoach ? '참여 인원' : '참여중인 멤버'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; overflow-y: scroll; padding: 0 12px;">
            <div v-if="is_show_manager" style=" margin-top: 20px;">
                <div style="margin-bottom: 8px; font-weight: 700; font-size: 14px; line-height: 24px;">{{ isCoach ? '전문가' : '매니저' }}</div>
                <div style="padding: 12px; border-radius: 12px; background-color: #f5f5f5;">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <div>
                            <ProfileImage style="width: 40px;" :image-path="creatorMember.image_path"></ProfileImage>
                        </div>
                        <div v-if="creatorMember.is_coach != 1" style="flex: 1; font-weight: 700; font-size: 14px; line-height: 24px;">{{ creatorMember.nic_name }}
                            <span style="font-weight: 700; color: var(--color-main);">
                                <DivisionPositionText :position="creatorMember.position" :positionProAbility="creatorMember.position_pro_ability"></DivisionPositionText>
                            </span>
                        </div>
                        <div v-else style="flex: 1; font-weight: 700; font-size: 14px; line-height: 24px;">
                            {{ creatorMember.nic_name }} 
                            <img v-if="creatorMember.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="margin-left:1px;width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                            <img v-else style="margin-left:1px;width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                        </div>
                        <!--<div @click="likeMember(creatorMember.member_idx, true); $Util.sendEventClick('멤버톡_참여멤버_좋아요')" v-if="creatorMember.member_idx != $GlobalStore.loginInfo().idx && creatorMember.is_liked === IS_LIKED.UNLIKE" style="border-radius: 6px; width: 67px; height: 32px; line-height: 32px; background-color: var(&#45;&#45;color-main); font-size: 12px; font-weight: 700; text-align: center;">슈팅</div>-->
                        <!--<div @click="unlikeMember(creatorMember.member_idx, true); $Util.sendEventClick('멤버톡_참여멤버_좋아요해제')" v-else-if="creatorMember.member_idx != $GlobalStore.loginInfo().idx && creatorMember.is_liked === IS_LIKED.LIKE" style="border-radius: 6px; width: 67px; height: 32px; line-height: 32px; display: flex; justify-content: center; align-items: center; border: 1px solid #d9d9d9; font-size: 12px; font-weight: 700; text-align: center;">-->
                        <!--<img style="width: 40px;" :src="require('@/assets/img/like_shoot.png')" alt="">-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
            <div style="margin-top: 20px;">
                <div style="margin-bottom: 8px; font-weight: 700; font-size: 14px; line-height: 24px;">{{ isCoach ? '회원' : '멤버' }}</div>
                <div style="padding: 0 12px; border-radius: 12px; background-color: #f5f5f5;">
                    <div v-for="each, i in commonMemberList" :key="i" style="display: flex; align-items: center; gap: 8px; padding-bottom: 10px; border-bottom: 1px solid #ebebeb; padding-top: 12px;">
                        <div>
                            <ProfileImage style="width: 40px;" :image-path="each.image_path"></ProfileImage>
                        </div>
                        <div style="flex: 1; font-weight: 700; font-size: 14px; line-height: 24px;">
                            {{ each.nic_name }}
                            <span style="font-weight: 700; color: var(--color-main);">
                                <DivisionPositionText :position="each.position" :positionProAbility="each.position_pro_ability"></DivisionPositionText>
                            </span>
                        </div>
                        <!-- <div @click="likeMember(each.member_idx, false, i); $Util.sendEventClick('멤버톡_참여멤버_좋아요')" v-if="each.member_idx != $GlobalStore.loginInfo().idx && each.is_liked === IS_LIKED.UNLIKE" style="border-radius: 6px; width: 67px; height: 32px; line-height: 32px; border: 1px solid #bbbbbb; font-size: 12px; font-weight: 700; text-align: center;">슈팅</div>
                        <div @click="unlikeMember(each.member_idx, false, i); $Util.sendEventClick('멤버톡_참여멤버_좋아요해제')" v-else-if="each.member_idx != $GlobalStore.loginInfo().idx && each.is_liked === IS_LIKED.LIKE" style="border-radius: 6px; width: 67px; height: 32px; line-height: 32px; display: flex; justify-content: center; align-items: center; border: 1px solid #d9d9d9; font-size: 12px; font-weight: 700; text-align: center;">
                            <img style="width: 40px;" :src="require('@/assets/img/like_shoot.png')" alt="">
                        </div> -->
                        <div v-show="each.member_idx != $GlobalStore.loginInfo().idx" @touchstart="touchStart(each, i)" @touchend="touchEnd(each, i)" style="border: 1px solid #bbbbbb; border-radius: 8px; width: 67px; height: 32px; text-align: center; display: flex; justify-content: center; align-items: center;">
                            <div @touchstart.stop="touchStart(each, i)" @touchend.stop="touchEnd(each, i)" v-show="!each.isShowBallImage && each.is_liked == IS_LIKED.UNLIKE" style="font-weight: 700; font-size: 12px; line-height: 32px; ">슈팅</div>
                            <div @touchstart.stop="touchStart(each, i)" @touchend.stop="touchEnd(each, i)" v-show="!each.isShowBallImage && each.is_liked == IS_LIKED.LIKE" style="font-weight: 700; font-size: 12px; line-height: 32px; ">슈팅됨</div>
                            <div style="position: relative;" @touchstart.stop="touchStart(each, i)" @touchend.stop="touchEnd(each, i)" v-show="each.isShowBallImage">
                                <img :style="{ opacity: each.is_liked == IS_LIKED.LIKE ? '1' : '0' }" ref="shoot" style="width: 40px; z-index: 1; opacity: 0; left: -15px; position: absolute; top: -1px;" :src="require('@/assets/img/shoot_orange.png')" alt="">
                                <img style="width: 16px; position: relative; z-index: 2; left: 0;" ref="soccerBall" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt="">
                            </div>
                        </div>
                        <div @click="setIsShowPopMenu(each)" v-if="creatorMember.member_idx == $GlobalStore.loginInfo().idx" style="display: flex; flex-direction: column; gap: 3px; margin-left: 16px;">
                            <div style="width: 5px; height: 5px; border-radius: 50%; background-color: #210f03;"></div>
                            <div style="width: 5px; height: 5px; border-radius: 50%; background-color: #210f03;"></div>
                            <div style="width: 5px; height: 5px; border-radius: 50%; background-color: #210f03;"></div>
                        </div>
                    </div>
                </div>
                <div v-if="isCoach && creatorMember.member_idx == $GlobalStore.loginInfo().idx" @click="showInviteMemberList" style="height: 48px; margin-top: 20px; border-radius: 12px; background: #f5f5f5; text-align: center; line-height: 48px; color: #4b8aff; font-weight: 500; font-size: 14px;">새로운 회원 초대하기</div>
            </div>
        </div>
        <BottomPopupMenu :is-open="isShowPopupMenu" :menu-options="menuOptions"></BottomPopupMenu>
        <CommonPopupFrame :isOpen="isOpenPopupFrame" :closeCompleteAction="closePopupFrame" :changeHeight="232" :changeHeightUnit="'px'">
            <div style="padding: 16px 20px;">
                <div style="font-weight: 700; line-height: 24px;">닫기</div>
                <div v-if="popupType === 'manager'" style="font-weight: 700; font-size: 20px; line-height: 24px; text-align: center; margin-top: 32px;">정말로 이분에게 매니저 권한을 넘길까요?</div>
                <div v-else style="font-weight: 700; font-size: 20px; line-height: 24px; text-align: center; margin-top: 32px;">{{ isCoach ? '정말로 채팅방에서 내보낼까요?' : '정말로 멤버톡에서 내보낼까요?' }}</div>
                <div @click="handOverManager(); $Util.sendEventClick('멤버톡_참여멤버_매니저권한넘기기')" v-if="popupType === 'manager'" style="margin-top: 40px; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">확인</div>
                <div @click="emitMember(); $Util.sendEventClick('멤버톡_참여멤버_멤버방출')" v-else style="margin-top: 40px; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">확인</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ProfileImage from '@/components/common/ProfileImage'
import ResponseCode from '@/ResponseCode';
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import DivisionPositionText from '@/components/common/DivisionPositionText'
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame';
import {JOIN_CHAT_TYPE, TEAM_TYPE} from "../../../Constants";

const IS_LIKED = {
    LIKE: '1',
    UNLIKE: '0'
}

export default {
    name: 'MemberTalkMemberList',
    components: { MercenaryHeader, ProfileImage, BottomPopupMenu, CommonPopupFrame, DivisionPositionText },
    props: {
        creatorIdx: {
            type: [Number, String],
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        memberTalkIdx: {
            type: [Number, String],
            default: -1
        },
        is_show_manager: {
            type: Boolean,
            default: true,
        },
        isCoach: {
            type: Boolean,
            default: false
        },
        chat : {
            type : Object,
            default : () => {}
        }
    },
    data() {
        return {
            commonMemberList: [],
            creatorMember: {},
            isShowPopupMenu: false,
            menuOptions: {},
            isOpenPopupFrame: false,
            popupType: null,
            memberList: [],
            selectMember: {},
            IS_LIKED: IS_LIKED,
            TEAM_TYPE: TEAM_TYPE
        }
    },
    methods: {
        async getMemberTalKDetail(isInvite) {
            if (isInvite) {
                this.memberList = []
                this.creatorMember = {}
                this.commonMemberList = []
            }

            if(this.chat.type == JOIN_CHAT_TYPE.OPEN){
                const parameters = {}
                parameters.chat_idx = this.chat.idx;
                const res = await this.$Axios.get('/api/chat/members', { params: parameters });
                this.memberList = res.data.members
            }else {
                const parameters = {}
                parameters.join_idx = this.memberTalkIdx;
                parameters.is_with_password = true;
                const res = await this.$Axios.get('/api/join/detail', { params: parameters })

                const memberTalkMembers = res.data.join_members

                this.memberList = memberTalkMembers
            }

            this.memberList.forEach((item) => {
                this.$set(item, 'isShowBallImage', false);
            });
            this.memberList.forEach(item => {
                if (this.creatorIdx === item.member_idx) {
                    this.creatorMember = item
                } else {
                    this.commonMemberList.push(item)
                }
            })
            if (isInvite) {
                this.completeAction()
            }
        },
        touchStart(memberInfo, index) {
            if (memberInfo.is_liked === IS_LIKED.UNLIKE) {
                this.$set(this.commonMemberList[index], 'isShowBallImage', true)
            }
        },
        touchEnd(memberInfo, index) {
            if (memberInfo.is_liked === IS_LIKED.UNLIKE) {
                this.$refs.soccerBall[index].style.transition = 'all 0.3s'
                this.$refs.soccerBall[index].style.transform = 'rotate(60deg)'
                this.$refs.soccerBall[index].style.left = '8px'
                this.$refs.shoot[index].style.opacity = '1'
                this.$refs.shoot[index].style.transition = 'all 0.3s'
                this.likeMember(memberInfo.member_idx, false, index)
            } else {
                this.unlikeMember(memberInfo.member_idx, false, index)
            }

            // let likeTemp = this.curLikeYn === IS_LIKE.UNLIKE ? '1' : '0'
            // let likeNumber = this.curLikeYn === IS_LIKE.UNLIKE ? this.curLikeNumber + 1 : this.curLikeNumber - 1
            // this.$set(this.copySoccerHows, 'like_yn', likeTemp);
            // this.$set(this.copySoccerHows, 'like_number', likeNumber);
            // this.toggleLike()
        },
        async likeMember(member_idx, isManager, index) {
            const formData = new FormData()
            formData.append('target_idx', member_idx)

            const res = await this.$Axios.post('/api/like/member/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                if (isManager) {
                    this.$set(this.creatorMember, 'is_liked', IS_LIKED.LIKE)
                } else {
                    setTimeout(() => {
                        this.$set(this.commonMemberList[index], 'is_liked', IS_LIKED.LIKE)
                        this.$set(this.commonMemberList[index], 'isShowBallImage', false)
                    }, 500)
                }
            }
        },
        async unlikeMember(member_idx, isManager, index) {
            const formData = new FormData()
            formData.append('target_idx', member_idx)

            const res = await this.$Axios.post('/api/like/member/delete', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                if (isManager) {
                    this.$set(this.creatorMember, 'is_liked', IS_LIKED.UNLIKE)
                } else {
                    this.$refs.soccerBall[index].style.transform = 'rotate(0deg)'
                    this.$refs.soccerBall[index].style.left = '0'
                    this.$set(this.commonMemberList[index], 'is_liked', IS_LIKED.UNLIKE)
                    this.$set(this.commonMemberList[index], 'isShowBallImage', false)
                }
            }
        },
        showInviteMemberList() {
            this.$GlobalStore.addModal('InviteMemberPage', { join_idx: this.memberTalkIdx, completeAction: this.getMemberTalKDetail })
        },
        async handOverManager() {
            const parameters = {};
            parameters.join_idx = this.memberTalkIdx;
            parameters.member_idx = this.selectMember.member_idx;
            parameters.member_type = this.selectMember.member_type;
            const res = await this.$Axios.post('/api/join/change/host', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.isOpenPopupFrame = false
                this.$GlobalStore.closeLastModal();
                this.completeAction();
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async emitMember() {
            const parameters = {};
            parameters.join_idx = this.memberTalkIdx;
            parameters.member_idx = this.selectMember.member_idx;
            parameters.member_type = this.selectMember.member_type;
            const res = await this.$Axios.post('/api/join/dropout', parameters);

            if (res.data.code === ResponseCode.SUCCESS) {
                this.isOpenPopupFrame = false;
                this.$GlobalStore.closeLastModal();
                this.completeAction();
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        closePopupFrame() {
            this.isOpenPopupFrame = false
        },
        setIsShowPopMenu(member) {
            this.selectMember = member
            this.isShowPopupMenu = true
            const labelAndAction = []

            if (this.creatorMember.is_coach == 0) {
                labelAndAction.push(
                    {
                        label: '매니저 넘기기', action: () => {
                            this.popupType = 'manager'
                            this.isShowPopupMenu = false
                            this.isOpenPopupFrame = true
                        }
                    },
                )
            }

            labelAndAction.push(
                {
                    label: '내보내기', action: () => {
                        this.popupType = 'exit'
                        this.isShowPopupMenu = false
                        this.isOpenPopupFrame = true
                    }
                },
            )

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopupMenu = false;
                }
            }
        },
    },
    created() {
        this.getMemberTalKDetail()
        this.emitMember = this.$Once(this.emitMember);
        this.handOverManager = this.$Once(this.handOverManager);
    }
}
</script>

<style scoped></style>